import React from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import {
  FormControl,
  Box,
  MenuItem,
  Select,
  makeStyles,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { isDevEnv, isQaEnv } from 'commons/getEnv'
import SimpleInput from 'app/componentV4/Input/SimpleInput'

const useStyles = makeStyles(() => ({
  noArrowInput: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
      {
        '-webkit-appearance': 'none',
        margin: 0,
      },
    ' & .MuiInputBase-input': {
      padding: '1.4rem !important',
    },
  },
  noLabel: {
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiInputBase-input': {
      padding: '1.4rem !important',
    },
  },
  errorText: {
    color: 'red',
    fontSize: '0.875rem',
    marginTop: '4px',
  },
}))

const FrequencyUnit = ({ onFrequencyChange }) => {
  const classes = useStyles()

  // Bind Formik field for 'duration' and 'frequencyUnit'
  const [durationField, durationMeta, durationHelpers] = useField('duration')
  const [unitField, unitMeta, unitHelpers] = useField('frequencyUnit')

  const handleTimeChange = (event) => {
    durationHelpers.setValue(event.target.value)
  }

  const handleUnitChange = (event) => {
    unitHelpers.setValue(event.target.value)
  }

  const handleClick = () => {
    onFrequencyChange('repeat')
  }

  const onDurationKey = (event) => {
    const value = event.target.value
    if (Number(value) <= 0) {
      event.target.value = ''
    }
    handleTimeChange(event)
  }

  return (
    <div>
      <Box alignItems="center" className="sm:flex">
        <div className="flex space-x-5 w-full">
          <FormControl
            variant="outlined"
            className="w-128 rounded-8 border border-grey-input h-auto bg-white text-grey-300 text-left"
          >
            <SimpleInput
              {...durationField}
              id="duration"
              name="duration"
              type="number"
              className={clsx(classes.noArrowInput, 'p-0')}
              onChange={handleTimeChange}
              onClick={handleClick}
              onKeyUp={onDurationKey}
              onKeyDown={(event) => {
                if (['e', 'E', '+', '-'].includes(event.key))
                  event.preventDefault()
              }}
            />
          </FormControl>

          <FormControl
            variant="outlined"
            className={clsx(
              classes.noLabel,
              'w-full rounded-8 border border-grey-input h-auto bg-white text-grey-300 text-left',
            )}
          >
            <Select
              {...unitField}
              name="frequencyUnit"
              value={unitField.value}
              onChange={handleUnitChange}
              onClick={handleClick}
            >
              {(isDevEnv() || isQaEnv()) && (
                <MenuItem value="minute">
                  <FormattedMessage id="manageChannels.selectorRetry.custom.until.minute.lable" />
                </MenuItem>
              )}

              <MenuItem value="hour">
                <FormattedMessage id="createNotificationBeacon.dialog.frequency.hours.label" />
              </MenuItem>
              <MenuItem value="day">
                <FormattedMessage id="createNotificationBeacon.dialog.frequency.days.label" />
              </MenuItem>
              <MenuItem value="month">
                <FormattedMessage id="createNotificationBeacon.dialog.frequency.months.label" />
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        {(isDevEnv() || isQaEnv()) && unitField.value === 'minute' && (
          <Typography className="py-2 text-red w-full px-2">
            (For test only)
          </Typography>
        )}
      </Box>
    </div>
  )
}

FrequencyUnit.propTypes = {
  onFrequencyChange: PropTypes.func,
}

export default FrequencyUnit
